import React from "react";
import { useNavigate } from "react-router-dom";
import { Mail, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";

export const VerifyPendingPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-secondary">
      <div className="max-w-md w-full bg-white border border-border rounded-md p-10 text-center">
        <div className="w-20 h-20 bg-accent/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Mail className="w-10 h-10 text-accent" />
        </div>
        <h1 className="font-heading text-3xl font-bold mb-3">Check your email</h1>
        <p className="text-muted-foreground mb-6">
          We sent a verification link to your email address. Click it to confirm your
          account, then our team will review your business application.
        </p>
        <div className="bg-secondary rounded-md p-4 mb-6 text-left space-y-3 text-sm text-muted-foreground">
          <div className="flex gap-3 items-start">
            <span className="w-6 h-6 rounded-full bg-accent text-white text-xs flex items-center justify-center shrink-0">1</span>
            Verify your email via the link we sent
          </div>
          <div className="flex gap-3 items-start">
            <span className="w-6 h-6 rounded-full bg-accent text-white text-xs flex items-center justify-center shrink-0">2</span>
            Our team reviews your documents (1–2 business days)
          </div>
          <div className="flex gap-3 items-start">
            <span className="w-6 h-6 rounded-full bg-accent text-white text-xs flex items-center justify-center shrink-0">3</span>
            Once approved you get full platform access
          </div>
        </div>
        <div className="flex items-center gap-2 justify-center text-amber-600 text-sm mb-6">
          <Clock className="w-4 h-4" />
          Account approval typically takes 1–2 business days
        </div>
        <Button variant="outline" onClick={() => navigate("/login")} className="w-full">
          Back to Login
        </Button>
      </div>
    </div>
  );
};

export default VerifyPendingPage;
